// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.career-user-avatar {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 8px;
  border: none;
  border-radius: 48px;
  cursor: pointer;
  background-color: var(--hrone-theme-backgroundsecondary, #f6f6f6);
}

.career-user-avatar-icon {
  display: block;
  width: 24px;
  height: 24px;
}

.mat-mdc-menu-panel.career-user-avatar-menu {
  min-width: 220px;
  border: 1px solid #dddddd;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
}
.mat-mdc-menu-panel.career-user-avatar-menu .mat-mdc-menu-content {
  padding: 0;
}
.mat-mdc-menu-panel.career-user-avatar-menu .mat-mdc-menu-item {
  min-height: 48px;
  padding: 0 16px;
}
.mat-mdc-menu-panel.career-user-avatar-menu .mat-mdc-menu-item:hover {
  background-color: #f4f4f4;
}
.mat-mdc-menu-panel.career-user-avatar-menu .mat-mdc-menu-item .mat-mdc-menu-item-text {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #1d1d1d;
}
.mat-mdc-menu-panel.career-user-avatar-menu .career-user-avatar-menu-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/global/components/user-avatar/user-avatar.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iEAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AACF;;AAGA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;AAAF;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,gBAAA;EACA,eAAA;AADJ;AAGI;EACE,yBAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAFN;AAME;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAJJ","sourcesContent":[".career-user-avatar {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  border: none;\n  border-radius: 48px;\n  cursor: pointer;\n  background-color: var(--hrone-theme-backgroundsecondary, #f6f6f6);\n}\n\n.career-user-avatar-icon {\n  display: block;\n  width: 24px;\n  height: 24px;\n}\n\n\n.mat-mdc-menu-panel.career-user-avatar-menu {\n  min-width: 220px;\n  border: 1px solid #dddddd;\n  border-radius: 12px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);\n\n  .mat-mdc-menu-content {\n    padding: 0;\n  }\n\n  .mat-mdc-menu-item {\n    min-height: 48px;\n    padding: 0 16px;\n\n    &:hover {\n      background-color: #f4f4f4;\n    }\n\n    .mat-mdc-menu-item-text {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      font-size: 14px;\n      color: #1d1d1d;\n    }\n  }\n\n  .career-user-avatar-menu-icon {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
